/* (c) Copyright Frontify Ltd., all rights reserved. */

export const CODE_PLUGIN = 'code-plugin';
